import { styledByTheme } from "../../../../../../themes/architecture/styled-by-theme";
import { Separator777Box } from "./separator.777.box";
import { SeparatorDefaultBox } from "./separator.default.box";
import {SeparatorMrGreenBox} from "./seperator.mrgreen.box";

export const SeparatorBox = styledByTheme(SeparatorDefaultBox)
    .forCasino777(Separator777Box)
    .forMrGreen(SeparatorMrGreenBox)
    .apply();


